import AuthService from './AuthService'
import axios from 'axios'

import { throttleAdapterEnhancer, cacheAdapterEnhancer } from 'axios-extensions'

const enhacedAdapter = throttleAdapterEnhancer(
  cacheAdapterEnhancer(axios.defaults.adapter)
)

const http = axios.create({
  adapter: enhacedAdapter
})

const api = axios.create({
  adapter: enhacedAdapter,
  baseURL: process.env.REACT_APP_URL_API
})

const fetchBase64 = (url) => {
  return http.get(url, { responseType: 'arraybuffer' }).then((response) => {
    const extension = response.headers['content-type'].toLowerCase()
    const content = Buffer.from(response.data, 'binary').toString('base64')
    return `data:${extension};base64,${content}`
  })
}

const authorizationMiddleware = (request) => {
  const authService = new AuthService()

  const token = authService.getToken()

  request.headers.common.Authorization = `Bearer ${token}`

  return request
}

const refreshTokenMiddleware = async (error) => {
  const authService = new AuthService()

  if (error.response?.status === 401) {
    const refreshToken = authService.getRefresh()

    if (refreshToken) {
      authService.requestNewToken(refreshToken)
    } else {
      authService.signOut()
    }
  }

  return Promise.reject(error)
}

const unitMiddleware = request => {
  const authService = new AuthService()

  const { id: unitId } = authService.getUnit() || {}

  request.headers.common['X-Unit-ID'] = unitId

  if (request.data) {
    request.data.unit_id = unitId
  }

  return request
}

api.interceptors.request.use(authorizationMiddleware, refreshTokenMiddleware)

api.interceptors.request.use(unitMiddleware)

api.interceptors.response.use((res) => res, refreshTokenMiddleware)

export { api, http, fetchBase64 }
